// ---------- l'écran de lancement ----------
// Le calque qui couvre le démarrage, du tout premier pixel jusqu'à ce que le chemin soit peint.
// Repris de Codigrid (src/splash.ts là-bas), pour les deux mêmes raisons :
//
// 1. Il est OPAQUE DANS LE BALISAGE (index.html), donc présent dès la première image : il n'y a
//    pas d'instant où le système montre autre chose — l'instantané de la dernière partie, un
//    écran blanc —, et il démarre sur l'aplat violet de la fenêtre de lancement d'Android
//    (android/…/values/splash_background.xml), si bien qu'on ne voit qu'un seul lancement.
// 2. Il porte la marque : les tuiles de VERBIGRID arrivent une à une, puis la colonne du ruban
//    s'allume — le jeu en une image, avant d'y entrer.
//
// L'animation est en CSS et ne joue qu'UNE fois (pas de canevas, pas de boucle d'images) : un
// lancement ne doit rien coûter à la batterie. Ce module ne fait que tenir la durée minimale et
// retirer le calque.

/** Assez pour voir la séquence (les tuiles finissent à ~1 s, cf. style.css), pas plus : un
 *  lancement à chaud n'attend que ce qui reste de cette durée. */
const MIN_MS = 1400;
/** ⚠ La durée du fondu de `.splash` dans style.css : le calque est retiré du document après. */
const FADE_MS = 420;

const started = performance.now();
let done = false;

/** Retire le calque — au plus tôt MIN_MS après le lancement. Appelé quand le premier écran
 *  (le chemin, ou un état d'erreur) est peint dessous. */
export function hideSplash(): void {
  if (done) return;
  const el = document.getElementById('splash');
  if (!el) return;
  const wait = MIN_MS - (performance.now() - started);
  if (wait > 0) return void setTimeout(hideSplash, wait);
  done = true;
  el.classList.add('gone');
  // Retiré, et pas seulement transparent : un calque plein écran garderait une surface à
  // composer à chaque image.
  setTimeout(() => el.remove(), FADE_MS + 40);
}
